var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 80C24.5 80 20.05 84.5 20.05 90C20.05 95.5 24.5 100 30 100C35.5 100 40 95.5 40 90C40 84.5 35.5 80 30 80ZM0 0V10H10L28 47.95L21.25 60.2C20.45 61.6 20 63.25 20 65C20 70.5 24.5 75 30 75H90V65H32.1C31.4 65 30.85 64.45 30.85 63.75L31 63.15L35.5 55H72.75C76.5 55 79.8 52.95 81.5 49.85L99.4 17.4C99.8 16.7 100 15.85 100 15C100 12.25 97.75 10 95 10H21.05L16.35 0H0ZM80 80C74.5 80 70.05 84.5 70.05 90C70.05 95.5 74.5 100 80 100C85.5 100 90 95.5 90 90C90 84.5 85.5 80 80 80Z",
    fill: "#F6FEFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.43f4aff5.svg";
export { ForwardRef as ReactComponent };